import React from 'react';
import { Formik, Field } from 'formik';

// utils
import JSONparse from 'utils/json-parse-safe';

// components
import { FullHeightForm, ContentContainer } from 'components/SharedStyledElements';
import PanoptoField from 'pages/MerchantPages/Assets/Content/components/FormikFields/Panopto';
import FormAccordionHelper, { SectionType } from '../../components/AccordionHelper';

interface FormValues {
  panoptoVideoData: Record<string, any>;
}

const defaultValues: FormValues = {
  panoptoVideoData: {},
};

interface Props {
  rawContent: string;
  onSubmit: (contentString: string) => void;
  formId: string;
  closePanel: () => void;
}

const PanoptoContent = ({ rawContent, onSubmit, formId, closePanel }: Props) => {
  const initialValues: FormValues = {
    ...defaultValues,
    panoptoVideoData: JSONparse(rawContent).value || {},
  };

  const handleSubmit = ({ panoptoVideoData }: FormValues) => {
    const contentString = JSON.stringify(panoptoVideoData);
    onSubmit(contentString);
  };

  return (
    <Formik onSubmit={handleSubmit} initialValues={initialValues}>
      {() => (
        <FullHeightForm id={formId}>
          <FormAccordionHelper initialValues={initialValues} index={SectionType.Content} closePanel={closePanel} />
          <ContentContainer withPadding height="90%">
            <Field name="panoptoVideoData" component={PanoptoField} />
          </ContentContainer>
        </FullHeightForm>
      )}
    </Formik>
  );
};

export default PanoptoContent;
